import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { useSimpleToggle } from 'hooks';
import React, { FC } from 'react';

import { FilterDropdownButton } from 'components/FilterDropdown/Button';
import { FilterOpen } from 'components/FilterDropdown/FilterOpen';
import { FilterDropdownProps } from 'components/FilterDropdown/index';
import { Filterable, mapFilterable } from 'components/FilterDropdown/util';
import { useDebounce } from 'hooks/useDebounce';

import { useLocationGroups } from './hooks/useLocationGroups';

export const FilterLocationGroupDropdown: FC<
  FilterDropdownProps<Filterable>
> = ({ selected, setSelected, showTitle, enterprise, userId, error }) => {
  const { off, showContent: open, toggle: openUp } = useSimpleToggle();

  const { locationGroups, setQuery } = useLocationGroups(enterprise, userId);
  const debounceSetQuery = useDebounce(setQuery, 500);

  const name = 'locationGroup';

  return (
    <ClickAwayListener onClickAway={off}>
      <div>
        <FilterDropdownButton
          name={name}
          open={open}
          openUp={openUp}
          count={selected.length}
          clearFilter={() => setSelected([])}
          titles={selected.map(filterable => filterable.title)}
          showTitle={showTitle}
          setSelected={setSelected}
          selected={selected}
          error={error}
        />
        {open && (
          <FilterOpen
            name={name}
            selected={selected}
            setSelected={setSelected}
            options={mapFilterable(locationGroups, {
              name,
              titleAttr: 'title',
              idAttr: 'title',
            })}
            setQuery={debounceSetQuery}
          />
        )}
      </div>
    </ClickAwayListener>
  );
};
